// // import { db } from "../firebase";
// // import { collection, getDocs, doc, setDoc, updateDoc, query, orderBy, Timestamp, serverTimestamp, getDoc } from "firebase/firestore";

// // // Helper to get ISO week/year
// // function getISOWeekYear(date) {
// //   const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
// //   const dayNum = d.getUTCDay() || 7;
// //   d.setUTCDate(d.getUTCDate() + 4 - dayNum);
// //   const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
// //   const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
// //   return { week: weekNum, year: d.getUTCFullYear() };
// // }

// // export const FineService = {
// //   fetchUsers: async () => {
// //     const userSnapshot = await getDocs(collection(db, "users"));
// //     return userSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
// //       .sort((a, b) => a.userName.localeCompare(b.userName));
// //   },

// //   fetchFines: async (users) => {
// //     const finesCollection = collection(db, "Fines");
// //     const usersSnapshot = await getDocs(finesCollection);
// //     let finesList = [];
// //     let totalFinesAmount = 0;
// //     let pendingFinesAmount = 0;

// //     for (const userDoc of usersSnapshot.docs) {
// //       const userId = userDoc.id;
// //       const userFinesCollection = collection(db, "Fines", userId, "fines");
// //       const finesSnapshot = await getDocs(query(userFinesCollection, orderBy("date", "desc")));
// //       const userInfo = users.find(u => u.id === userId) || { userName: "Unknown User" };

// //       for (const fineDoc of finesSnapshot.docs) {
// //         finesList.push({ fineId: fineDoc.id, userId, userName: userInfo.userName, ...fineDoc.data() });
// //       }

// //       const userData = userDoc.data();
// //       totalFinesAmount += userData.TotalFine || 0;
// //       pendingFinesAmount += userData.PendingFine || 0;
// //     }

// //     return { finesList, totalFinesAmount, pendingFinesAmount };
// //   },



// //   addFineNormal: async (selectedUsers, fineType, amount, date) => {
// //     const timestamp = serverTimestamp();
// //     const users100 = selectedUsers.map((id) => id); // all users get normal fine
// //     const users200 = []; // rulewise doubling nahi

// //     await Promise.all(selectedUsers.map(async (userId) => {
// //       const userRef = doc(db, "Fines", userId);
// //       const userDoc = await getDoc(userRef);
// //       const userAmount = parseFloat(amount);

// //       if (userDoc.exists()) {
// //         await updateDoc(userRef, {
// //           TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
// //           PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
// //           lastUpdated: timestamp,
// //         });
// //       } else {
// //         await setDoc(userRef, {
// //           TotalFine: userAmount,
// //           PendingFine: userAmount,
// //           createdAt: timestamp,
// //           lastUpdated: timestamp,
// //         });
// //       }

// //       const fineId = doc(collection(userRef, "fines")).id;
// //       await setDoc(doc(userRef, "fines", fineId), {
// //         fineType,
// //         amount: userAmount,
// //         date,
// //         status: "Pending",
// //         createdAt: timestamp,
// //       });
// //     }));

// //     return { users100, users200, fineAmounts: null };
// //   },

  
// //   addFineRulewise: async (selectedUsers, fineType, amount, date, allUsers) => {
// //     const timestamp = serverTimestamp();
// //     const { week: currentWeek, year: currentYear } = getISOWeekYear(new Date(date));
// //     let fineAmounts = {};
// //     let users100 = [];
// //     let users200 = [];

// //     // Determine if each user already has fine this week
// //     await Promise.all(selectedUsers.map(async userId => {
// //       const userFinesCollection = collection(db, "Fines", userId, "fines");
// //       const finesSnapshot = await getDocs(userFinesCollection);
// //       let hasFineThisWeek = false;

// //       finesSnapshot.forEach(doc => {
// //         const fineData = doc.data();
// //         if (fineData.date) {
// //           const { week, year } = getISOWeekYear(new Date(fineData.date));
// //           if (week === currentWeek && year === currentYear) hasFineThisWeek = true;
// //         }
// //       });

// //       const userObj = allUsers.find(u => u.id === userId);
// //       const userName = userObj ? userObj.userName : userId;

// //       if (hasFineThisWeek) {
// //         fineAmounts[userId] = parseFloat(amount) * 2;
// //         users200.push(userName);
// //       } else {
// //         fineAmounts[userId] = parseFloat(amount);
// //         users100.push(userName);
// //       }
// //     }));

// //     // Add fines for all users
// //     await Promise.all(selectedUsers.map(async userId => {
// //       const userRef = doc(db, "Fines", userId);
// //       const userDoc = await getDoc(userRef);
// //       const userAmount = fineAmounts[userId];

// //       if (userDoc.exists()) {
// //         await updateDoc(userRef, {
// //           TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
// //           PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
// //           lastUpdated: timestamp,
// //         });
// //       } else {
// //         await setDoc(userRef, {
// //           TotalFine: userAmount,
// //           PendingFine: userAmount,
// //           createdAt: timestamp,
// //           lastUpdated: timestamp,
// //         });
// //       }

// //       const fineId = doc(collection(userRef, "fines")).id;
// //       await setDoc(doc(userRef, "fines", fineId), {
// //         fineType,
// //         amount: userAmount,
// //         date,
// //         status: "Pending",
// //         createdAt: timestamp,
// //       });
// //     }));

// //     return { users100, users200, fineAmounts };
// //   },


  

// //   updateHistory: async (totalFinesAmount, pendingFinesAmount) => {
// //     const collectedAmount = totalFinesAmount - pendingFinesAmount;
// //     await setDoc(doc(db, "fineAmountHistory", "latest"), {
// //       totalFinesAmount,
// //       pendingFinesAmount,
// //       collectedAmount,
// //       createdAt: Timestamp.now(),
// //     }, { merge: true });
// //   }
// // };

// // import { db } from "../firebase";
// // import {
// //   collection,
// //   getDocs,
// //   doc,
// //   setDoc,
// //   updateDoc,
// //   query,
// //   orderBy,
// //   Timestamp,
// //   serverTimestamp,
// //   getDoc,
// // } from "firebase/firestore";

// // // Helper to get ISO week/year
// // function getISOWeekYear(date) {
// //   const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
// //   const dayNum = d.getUTCDay() || 7;
// //   d.setUTCDate(d.getUTCDate() + 4 - dayNum);
// //   const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
// //   const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
// //   return { week: weekNum, year: d.getUTCFullYear() };
// // }

// // export const FineService = {
// //   fetchUsers: async () => {
// //     const userSnapshot = await getDocs(collection(db, "users"));
// //     return userSnapshot.docs
// //       .map((doc) => ({ id: doc.id, ...doc.data() }))
// //       .sort((a, b) => a.userName.localeCompare(b.userName));
// //   },

// //   fetchFines: async (users) => {
// //     const finesCollection = collection(db, "Fines");
// //     const usersSnapshot = await getDocs(finesCollection);
// //     let finesList = [];
// //     let totalFinesAmount = 0;
// //     let pendingFinesAmount = 0;

// //     for (const userDoc of usersSnapshot.docs) {
// //       const userId = userDoc.id;
// //       const userFinesCollection = collection(db, "Fines", userId, "fines");
// //       const finesSnapshot = await getDocs(query(userFinesCollection, orderBy("date", "desc")));
// //       const userInfo = (users || []).find((u) => u.id === userId) || { userName: "Unknown User" };

// //       for (const fineDoc of finesSnapshot.docs) {
// //         finesList.push({ fineId: fineDoc.id, userId, userName: userInfo.userName, ...fineDoc.data() });
// //       }

// //       const userData = userDoc.data();
// //       totalFinesAmount += userData.TotalFine || 0;
// //       pendingFinesAmount += userData.PendingFine || 0;
// //     }

// //     return { finesList, totalFinesAmount, pendingFinesAmount };
// //   },

// //   addFineNormal: async (selectedUsers, fineType, amount, date, allUsers = []) => {
// //     const timestamp = serverTimestamp();
// //     const users100 = [];
// //     const users200 = []; // no doubling in normal fine

// //     await Promise.all(
// //       (selectedUsers || []).map(async (userId) => {
// //         const userRef = doc(db, "Fines", userId);
// //         const userDoc = await getDoc(userRef);
// //         const userAmount = parseFloat(amount);
// //         const userObj = (allUsers || []).find((u) => u.id === userId);
// //         const userName = userObj ? userObj.userName : userId;

// //         users100.push(userName);

// //         if (userDoc.exists()) {
// //           await updateDoc(userRef, {
// //             TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
// //             PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
// //             lastUpdated: timestamp,
// //           });
// //         } else {
// //           await setDoc(userRef, {
// //             TotalFine: userAmount,
// //             PendingFine: userAmount,
// //             createdAt: timestamp,
// //             lastUpdated: timestamp,
// //           });
// //         }

// //         const fineId = doc(collection(userRef, "fines")).id;
// //         await setDoc(doc(userRef, "fines", fineId), {
// //           fineType,
// //           amount: userAmount,
// //           date,
// //           status: "Pending",
// //           createdAt: timestamp,
// //         });
// //       })
// //     );

// //     return { users100, users200, fineAmounts: null };
// //   },

// //   addFineRulewise: async (selectedUsers, fineType, amount, date, allUsers = []) => {
// //     const timestamp = serverTimestamp();
// //     const { week: currentWeek, year: currentYear } = getISOWeekYear(new Date(date));
// //     const fineAmounts = {};
// //     const users100 = [];
// //     const users200 = [];

// //     await Promise.all(
// //       (selectedUsers || []).map(async (userId) => {
// //         const userFinesCollection = collection(db, "Fines", userId, "fines");
// //         const finesSnapshot = await getDocs(userFinesCollection);
// //         let hasFineThisWeek = false;

// //         finesSnapshot.forEach((doc) => {
// //           const fineData = doc.data();
// //           if (fineData.date) {
// //             const { week, year } = getISOWeekYear(new Date(fineData.date));
// //             if (week === currentWeek && year === currentYear) hasFineThisWeek = true;
// //           }
// //         });

// //         const userObj = (allUsers || []).find((u) => u.id === userId);
// //         const userName = userObj ? userObj.userName : userId;

// //         if (hasFineThisWeek) {
// //           fineAmounts[userId] = parseFloat(amount) * 2;
// //           users200.push(userName);
// //         } else {
// //           fineAmounts[userId] = parseFloat(amount);
// //           users100.push(userName);
// //         }
// //       })
// //     );

// //     // Add fines
// //     await Promise.all(
// //       (selectedUsers || []).map(async (userId) => {
// //         const userRef = doc(db, "Fines", userId);
// //         const userDoc = await getDoc(userRef);
// //         const userAmount = fineAmounts[userId];

// //         if (userDoc.exists()) {
// //           await updateDoc(userRef, {
// //             TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
// //             PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
// //             lastUpdated: timestamp,
// //           });
// //         } else {
// //           await setDoc(userRef, {
// //             TotalFine: userAmount,
// //             PendingFine: userAmount,
// //             createdAt: timestamp,
// //             lastUpdated: timestamp,
// //           });
// //         }

// //         const fineId = doc(collection(userRef, "fines")).id;
// //         await setDoc(doc(userRef, "fines", fineId), {
// //           fineType,
// //           amount: userAmount,
// //           date,
// //           status: "Pending",
// //           createdAt: timestamp,
// //         });
// //       })
// //     );

// //     return { users100, users200, fineAmounts };
// //   },

// //   updateHistory: async (totalFinesAmount, pendingFinesAmount) => {
// //     const collectedAmount = totalFinesAmount - pendingFinesAmount;
// //     await setDoc(
// //       doc(db, "fineAmountHistory", "latest"),
// //       {
// //         totalFinesAmount,
// //         pendingFinesAmount,
// //         collectedAmount,
// //         createdAt: Timestamp.now(),
// //       },
// //       { merge: true }
// //     );
// //   },
// // };



// import { db } from "../firebase";
// import {
//   collection,
//   getDocs,
//   doc,
//   setDoc,
//   updateDoc,
//   query,
//   orderBy,
//   Timestamp,
//   serverTimestamp,
//   getDoc,
//   addDoc,
// } from "firebase/firestore";

// /* ============================= */
// /* ISO WEEK (Monday Start)      */
// /* ============================= */
// function getISOWeekYear(date) {
//   const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
//   const dayNum = d.getUTCDay() || 7; // Sunday = 7
//   d.setUTCDate(d.getUTCDate() + 4 - dayNum);
//   const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
//   const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
//   return { week: weekNum, year: d.getUTCFullYear() };
// }

// export const FineService = {
//   /* ============================= */
//   /* FETCH USERS                  */
//   /* ============================= */
//   fetchUsers: async () => {
//     const userSnapshot = await getDocs(collection(db, "users"));
//     return userSnapshot.docs
//       .map((doc) => ({ id: doc.id, ...doc.data() }))
//       .sort((a, b) => a.userName.localeCompare(b.userName));
//   },

//   /* ============================= */
//   /* FETCH FINES                  */
//   /* ============================= */
//   fetchFines: async (users) => {
//     const finesCollection = collection(db, "Fines");
//     const usersSnapshot = await getDocs(finesCollection);

//     let finesList = [];
//     let totalFinesAmount = 0;
//     let pendingFinesAmount = 0;

//     for (const userDoc of usersSnapshot.docs) {
//       const userId = userDoc.id;

//       const userFinesCollection = collection(db, "Fines", userId, "fines");
//       const finesSnapshot = await getDocs(
//         query(userFinesCollection, orderBy("date", "desc"))
//       );

//       const userInfo =
//         (users || []).find((u) => u.id === userId) || {
//           userName: "Unknown User",
//         };

//       for (const fineDoc of finesSnapshot.docs) {
//         finesList.push({
//           fineId: fineDoc.id,
//           userId,
//           userName: userInfo.userName,
//           ...fineDoc.data(),
//         });
//       }

//       const userData = userDoc.data();
//       totalFinesAmount += userData.TotalFine || 0;
//       pendingFinesAmount += userData.PendingFine || 0;
//     }

//     return { finesList, totalFinesAmount, pendingFinesAmount };
//   },



//   addFineNormal: async (selectedUsers, fineType, amount, date, allUsers = []) => {
//     try {
//       const timestamp = serverTimestamp();
//       const userAmount = parseFloat(amount) || 0;

//       const users100 = [];
//       const users200 = [];

//       await Promise.all(
//         selectedUsers.map(async (userId) => {
//           const userRef = doc(db, "Fines", userId);
//           const userDoc = await getDoc(userRef);

//           const userObj = allUsers.find((u) => u.id === userId);
//           const userName = userObj ? userObj.userName : userId;

//           users100.push(userName);

//           let currentTotalFine = 0;
//           let currentPendingFine = 0;

//           if (userDoc.exists()) {
//             currentTotalFine = userDoc.data().TotalFine || 0;
//             currentPendingFine = userDoc.data().PendingFine || 0;
//           }

//           // update parent doc
//           await setDoc(
//             userRef,
//             {
//               TotalFine: currentTotalFine + userAmount,
//               PendingFine: currentPendingFine + userAmount,
//               createdAt: userDoc.exists()
//                 ? userDoc.data().createdAt
//                 : timestamp,
//               lastUpdated: timestamp,
//             },
//             { merge: true }
//           );

//           // create fine document
//           const fineId = doc(collection(userRef, "fines")).id;

//           await setDoc(doc(userRef, "fines", fineId), {
//             fineType: fineType,
//             amount: userAmount,
//             date: date, // old structure same
//             status: "Pending",
//             createdAt: timestamp,
//           });
//         })
//       );

//       return {
//         users100,
//         users200,
//       };
//     } catch (error) {
//       console.error("Add fine error:", error);
//       throw error;
//     }
//   },



//   addFineRulewise: async (selectedUsers, fineType, amount, date, allUsers = []) => {
//     try {
//       const timestamp = serverTimestamp();
//       const currentDate = new Date(date);
//       currentDate.setHours(0, 0, 0, 0);

//       const { week: currentWeek, year: currentYear } = getISOWeekYear(currentDate);
//       const fineAmounts = {};
//       const users100 = [];
//       const users200 = [];

//       const inputAmount = parseFloat(amount) || 0;

//       // ====== Check if users already have fine this week ======
//       await Promise.all(
//         selectedUsers.map(async (userId) => {
//           const userFinesCollection = collection(db, "Fines", userId, "fines");
//           const finesSnapshot = await getDocs(userFinesCollection);

//           let hasFineThisWeek = false;
//           finesSnapshot.forEach((docSnap) => {
//             const fineData = docSnap.data();
//             if (fineData.date) {
//               const existingDate = fineData.date?.toDate
//                 ? fineData.date.toDate()
//                 : new Date(fineData.date);
//               existingDate.setHours(0, 0, 0, 0);
//               const { week, year } = getISOWeekYear(existingDate);
//               if (week === currentWeek && year === currentYear) hasFineThisWeek = true;
//             }
//           });

//           const userObj = allUsers.find((u) => u.id === userId);
//           const userName = userObj ? userObj.userName : userId;

//           if (hasFineThisWeek) {
//             fineAmounts[userId] = inputAmount * 2;
//             users200.push(userName);
//           } else {
//             fineAmounts[userId] = inputAmount;
//             users100.push(userName);
//           }
//         })
//       );

//       // ====== Update parent document and add fines ======
//       await Promise.all(
//         selectedUsers.map(async (userId) => {
//           const userRef = doc(db, "Fines", userId);
//           const userDoc = await getDoc(userRef);
//           const userAmount = fineAmounts[userId];

//           let currentTotal = 0;
//           let currentPending = 0;
//           let createdAt = timestamp;

//           if (userDoc.exists()) {
//             const data = userDoc.data();
//             currentTotal = data.TotalFine || 0;
//             currentPending = data.PendingFine || 0;
//             createdAt = data.createdAt || timestamp;
//           }

//           // Update parent document safely
//           await setDoc(
//             userRef,
//             {
//               TotalFine: currentTotal + userAmount,
//               PendingFine: currentPending + userAmount,
//               createdAt: createdAt,
//               lastUpdated: timestamp,
//             },
//             { merge: true }
//           );

//           // Add fine in subcollection with fineId (old structure)
//           const fineId = doc(collection(userRef, "fines")).id;
//           await setDoc(doc(userRef, "fines", fineId), {
//             fineType: fineType,
//             amount: userAmount,
//             date: date, // old structure same
//             status: "Pending",
//             createdAt: timestamp,
//           });
//         })
//       );

//       return { users100, users200, fineAmounts };
//     } catch (error) {
//       console.error("Error adding fine rulewise:", error);
//       throw error;
//     }
//   },

// // === PREVIEW FOR RULEWISE (NO DB UPDATE) ===
//   prepareRulewisePreview: async (selectedUsers, fineType, amount, date, allUsers = []) => {
//     const fineDate = new Date(date);
//     fineDate.setHours(0, 0, 0, 0);

//     const { week: currentWeek, year: currentYear } = getISOWeekYear(fineDate);
//     const fineAmounts = {};
//     const users100 = [];
//     const users200 = [];

//     await Promise.all((selectedUsers || []).map(async (userId) => {
//       const finesSnapshot = await getDocs(collection(db, "Fines", userId, "fines"));
//       let hasFineThisWeek = false;

//       finesSnapshot.forEach(docSnap => {
//         const fineData = docSnap.data();
//         if(fineData.date) {
//           const existingDate = fineData.date?.toDate ? fineData.date.toDate() : new Date(fineData.date);
//           existingDate.setHours(0,0,0,0);
//           const { week, year } = getISOWeekYear(existingDate);
//           if(week === currentWeek && year === currentYear) hasFineThisWeek = true;
//         }
//       });

//       const userObj = (allUsers || []).find(u => u.id === userId);
//       const userName = userObj ? userObj.userName : userId;
//       const baseAmount = parseFloat(amount);

//       if(hasFineThisWeek) {
//         fineAmounts[userId] = baseAmount * 2;
//         users200.push(userName);
//       } else {
//         fineAmounts[userId] = baseAmount;
//         users100.push(userName);
//       }
//     }));

//     return { users100, users200, fineAmounts };
//   },

//   // === PREVIEW FOR NORMAL (NO DB UPDATE) ===
//   prepareNormalPreview: async (selectedUsers, fineType, amount, date) => {
//     const fineAmounts = {};
//     const users100 = [];
//     const users200 = [];
//     const baseAmount = parseFloat(amount);

//     (selectedUsers || []).forEach(userId => {
//       fineAmounts[userId] = baseAmount;
//       users100.push(userId); // normal method has no users200
//     });

//     return { users100, users200, fineAmounts };
//   },





//   /* ============================= */
//   /* UPDATE HISTORY               */
//   /* ============================= */
//   updateHistory: async (totalFinesAmount, pendingFinesAmount) => {
//     const collectedAmount =
//       totalFinesAmount - pendingFinesAmount;

//     await setDoc(
//       doc(db, "fineAmountHistory", "latest"),
//       {
//         totalFinesAmount,
//         pendingFinesAmount,
//         collectedAmount,
//         createdAt: Timestamp.now(),
//       },
//       { merge: true }
//     );
//   },
// };









//   /* ============================= */
//   /* NORMAL FINE (No Double)     */
//   /* ============================= */
//   // addFineNormal: async (
//   //   selectedUsers,
//   //   fineType,
//   //   amount,
//   //   date,
//   //   allUsers = []
//   // ) => {
//   //   const timestamp = serverTimestamp();
//   //   const users100 = [];
//   //   const users200 = [];

//   //   const fineDate = new Date(date);
//   //   fineDate.setHours(0, 0, 0, 0);

//   //   await Promise.all(
//   //     (selectedUsers || []).map(async (userId) => {
//   //       const userRef = doc(db, "Fines", userId);
//   //       const userDoc = await getDoc(userRef);
//   //       const userAmount = parseFloat(amount);

//   //       const userObj = (allUsers || []).find((u) => u.id === userId);
//   //       const userName = userObj ? userObj.userName : userId;

//   //       users100.push(userName);

//   //       if (userDoc.exists()) {
//   //         await updateDoc(userRef, {
//   //           TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
//   //           PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
//   //           lastUpdated: timestamp,
//   //         });
//   //       } else {
//   //         await setDoc(userRef, {
//   //           TotalFine: userAmount,
//   //           PendingFine: userAmount,
//   //           createdAt: timestamp,
//   //           lastUpdated: timestamp,
//   //         });
//   //       }

//   //       await addDoc(collection(userRef, "fines"), {
//   //         fineType,
//   //         amount: userAmount,
//   //         date: Timestamp.fromDate(fineDate), // ✅ Save as Timestamp
//   //         status: "Pending",
//   //         createdAt: timestamp,
//   //       });
//   //     })
//   //   );

//   //   return { users100, users200, fineAmounts: null };
//   // },



//   /* ============================= */
//   /* RULEWISE FINE (Double Logic) */
//   /* ============================= */
//   // addFineRulewise: async (
//   //   selectedUsers,
//   //   fineType,
//   //   amount,
//   //   date,
//   //   allUsers = []
//   // ) => {
//   //   const timestamp = serverTimestamp();

//   //   const fineDate = new Date(date);
//   //   fineDate.setHours(0, 0, 0, 0);

//   //   const { week: currentWeek, year: currentYear } =
//   //     getISOWeekYear(fineDate);

//   //   const fineAmounts = {};
//   //   const users100 = [];
//   //   const users200 = [];

//   //   /* ===== CHECK WEEK ===== */
//   //   await Promise.all(
//   //     (selectedUsers || []).map(async (userId) => {
//   //       const userFinesCollection = collection(
//   //         db,
//   //         "Fines",
//   //         userId,
//   //         "fines"
//   //       );

//   //       const finesSnapshot = await getDocs(userFinesCollection);

//   //       let hasFineThisWeek = false;

//   //       finesSnapshot.forEach((docSnap) => {
//   //         const fineData = docSnap.data();

//   //         if (fineData.date) {
//   //           const existingDate =
//   //             fineData.date?.toDate
//   //               ? fineData.date.toDate()
//   //               : new Date(fineData.date);

//   //           existingDate.setHours(0, 0, 0, 0);

//   //           const { week, year } = getISOWeekYear(existingDate);

//   //           if (week === currentWeek && year === currentYear) {
//   //             hasFineThisWeek = true;
//   //           }
//   //         }
//   //       });

//   //       const userObj = (allUsers || []).find((u) => u.id === userId);
//   //       const userName = userObj ? userObj.userName : userId;

//   //       const baseAmount = parseFloat(amount);

//   //       if (hasFineThisWeek) {
//   //         fineAmounts[userId] = baseAmount * 2;
//   //         users200.push(userName);
//   //       } else {
//   //         fineAmounts[userId] = baseAmount;
//   //         users100.push(userName);
//   //       }
//   //     })
//   //   );

//   //   /* ===== ADD FINE ===== */
//   //   await Promise.all(
//   //     (selectedUsers || []).map(async (userId) => {
//   //       const userRef = doc(db, "Fines", userId);
//   //       const userDoc = await getDoc(userRef);
//   //       const userAmount = fineAmounts[userId];

//   //       if (userDoc.exists()) {
//   //         await updateDoc(userRef, {
//   //           TotalFine: (userDoc.data().TotalFine || 0) + userAmount,
//   //           PendingFine: (userDoc.data().PendingFine || 0) + userAmount,
//   //           lastUpdated: timestamp,
//   //         });
//   //       } else {
//   //         await setDoc(userRef, {
//   //           TotalFine: userAmount,
//   //           PendingFine: userAmount,
//   //           createdAt: timestamp,
//   //           lastUpdated: timestamp,
//   //         });
//   //       }

//   //       await addDoc(collection(userRef, "fines"), {
//   //         fineType,
//   //         amount: userAmount,
//   //         date: Timestamp.fromDate(fineDate), // ✅ Save properly
//   //         status: "Pending",
//   //         createdAt: timestamp,
//   //       });
//   //     })
//   //   );

//   //   return { users100, users200, fineAmounts };
//   // },
















import { db } from "../firebase";
import {
  collection, getDocs, doc, setDoc, getDoc,
  query, orderBy, Timestamp, serverTimestamp, 
} from "firebase/firestore";

function getISOWeekYear(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return { week: Math.ceil(((d - yearStart) / 86400000 + 1) / 7), year: d.getUTCFullYear() };
}

export const FineService = {

  /* ── FETCH USERS ── */
  fetchUsers: async () => {
    const snap = await getDocs(collection(db, "users"));
    return snap.docs
      .map(d => ({ id: d.id, ...d.data() }))
      .sort((a, b) => a.userName.localeCompare(b.userName));
  },

  /* ── FETCH FINES  (parallel — was sequential loop) ── */
  fetchFines: async (users) => {
    const usersSnap = await getDocs(collection(db, "Fines"));

    // 🔥 All subcollection queries fire at the same time
    const results = await Promise.all(
      usersSnap.docs.map(async (userDoc) => {
        const userId   = userDoc.id;
        const userData = userDoc.data();
        const userInfo = users?.find(u => u.id === userId) || { userName: "Unknown User" };

        const finesSnap = await getDocs(
          query(collection(db, "Fines", userId, "fines"), orderBy("date", "desc"))
        );

        const fines = finesSnap.docs.map(fd => ({
          fineId: fd.id,
          userId,
          userName: userInfo.userName,
          ...fd.data(),
        }));

        return {
          fines,
          totalFine:   userData.TotalFine   || 0,
          pendingFine: userData.PendingFine  || 0,
        };
      })
    );

    return {
      finesList:         results.flatMap(r => r.fines),
      totalFinesAmount:  results.reduce((s, r) => s + r.totalFine,   0),
      pendingFinesAmount:results.reduce((s, r) => s + r.pendingFine, 0),
    };
  },

  /* ── ADD FINE (normal) ── */
  addFineNormal: async (selectedUsers, fineType, amount, date, allUsers = []) => {
    const timestamp  = serverTimestamp();
    const userAmount = parseFloat(amount) || 0;
    const users100   = [];

    await Promise.all(selectedUsers.map(async (userId) => {
      const userRef = doc(db, "Fines", userId);
      const userDoc = await getDoc(userRef);
      const userObj = allUsers.find(u => u.id === userId);
      users100.push(userObj ? userObj.userName : userId);

      const prev = userDoc.exists() ? userDoc.data() : {};
      await setDoc(userRef, {
        TotalFine:   (prev.TotalFine   || 0) + userAmount,
        PendingFine: (prev.PendingFine || 0) + userAmount,
        createdAt:   prev.createdAt || timestamp,
        lastUpdated: timestamp,
      }, { merge: true });

      const fineId = doc(collection(userRef, "fines")).id;
      await setDoc(doc(userRef, "fines", fineId), {
        fineType, amount: userAmount, date, status: "Pending", createdAt: timestamp,
      });
    }));

    return { users100, users200: [] };
  },

  /* ── ADD FINE (rulewise) ── */
  addFineRulewise: async (selectedUsers, fineType, amount, date, allUsers = []) => {
    const timestamp   = serverTimestamp();
    const inputAmount = parseFloat(amount) || 0;
    const currentDate = new Date(date);
    currentDate.setHours(0, 0, 0, 0);
    const { week: currentWeek, year: currentYear } = getISOWeekYear(currentDate);
    const users100 = [], users200 = [], fineAmounts = {};

    // Check existing fines this week — all in parallel
    await Promise.all(selectedUsers.map(async (userId) => {
      const snap = await getDocs(collection(db, "Fines", userId, "fines"));
      const hasThisWeek = snap.docs.some(d => {
        const fd = d.data();
        if (!fd.date) return false;
        const ed = fd.date?.toDate ? fd.date.toDate() : new Date(fd.date);
        ed.setHours(0, 0, 0, 0);
        const { week, year } = getISOWeekYear(ed);
        return week === currentWeek && year === currentYear;
      });
      const userName = allUsers.find(u => u.id === userId)?.userName || userId;
      if (hasThisWeek) { fineAmounts[userId] = inputAmount * 2; users200.push(userName); }
      else             { fineAmounts[userId] = inputAmount;     users100.push(userName); }
    }));

    // Write all in parallel
    await Promise.all(selectedUsers.map(async (userId) => {
      const userRef  = doc(db, "Fines", userId);
      const userDoc  = await getDoc(userRef);
      const prev     = userDoc.exists() ? userDoc.data() : {};
      const userAmount = fineAmounts[userId];

      await setDoc(userRef, {
        TotalFine:   (prev.TotalFine   || 0) + userAmount,
        PendingFine: (prev.PendingFine || 0) + userAmount,
        createdAt:   prev.createdAt || timestamp,
        lastUpdated: timestamp,
      }, { merge: true });

      const fineId = doc(collection(userRef, "fines")).id;
      await setDoc(doc(userRef, "fines", fineId), {
        fineType, amount: userAmount, date, status: "Pending", createdAt: timestamp,
      });
    }));

    return { users100, users200, fineAmounts };
  },

  /* ── PREVIEW RULEWISE ── */
  prepareRulewisePreview: async (selectedUsers, fineType, amount, date, allUsers = []) => {
    const fineDate = new Date(date);
    fineDate.setHours(0, 0, 0, 0);
    const { week: currentWeek, year: currentYear } = getISOWeekYear(fineDate);
    const fineAmounts = {}, users100 = [], users200 = [];
    const baseAmount = parseFloat(amount);

    await Promise.all((selectedUsers || []).map(async (userId) => {
      const snap = await getDocs(collection(db, "Fines", userId, "fines"));
      const hasThisWeek = snap.docs.some(d => {
        const fd = d.data();
        if (!fd.date) return false;
        const ed = fd.date?.toDate ? fd.date.toDate() : new Date(fd.date);
        ed.setHours(0, 0, 0, 0);
        const { week, year } = getISOWeekYear(ed);
        return week === currentWeek && year === currentYear;
      });
      const userName = allUsers.find(u => u.id === userId)?.userName || userId;
      if (hasThisWeek) { fineAmounts[userId] = baseAmount * 2; users200.push(userName); }
      else             { fineAmounts[userId] = baseAmount;     users100.push(userName); }
    }));

    return { users100, users200, fineAmounts };
  },

  /* ── PREVIEW NORMAL ── */
  prepareNormalPreview: async (selectedUsers, fineType, amount) => {
    const baseAmount = parseFloat(amount);
    const fineAmounts = Object.fromEntries(selectedUsers.map(id => [id, baseAmount]));
    return { users100: [...selectedUsers], users200: [], fineAmounts };
  },

  /* ── UPDATE HISTORY ── */
  updateHistory: async (totalFinesAmount, pendingFinesAmount) => {
    await setDoc(doc(db, "fineAmountHistory", "latest"), {
      totalFinesAmount,
      pendingFinesAmount,
      collectedAmount: totalFinesAmount - pendingFinesAmount,
      createdAt: Timestamp.now(),
    }, { merge: true });
  },
};